import { useLocation } from "react-router-dom";
import {
  Box,
  Breadcrumbs,
  Grid,
  Theme,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

import { AccountDetail } from "components/AccountDetail";
import { PasswordChange } from "components/PasswordChange";
import Link from "components/shared/Link";
import { HeroText } from "components/shared/Typography";
import RightContent from "components/wrappers/RightContent";
import { IAssignedUser } from "types/user";

import { UserStatusPanel } from "./components/UserStatusPanel";

export const UserDetail = () => {
  const { state: userInfo } = useLocation<IAssignedUser>();
  const xs = useMediaQuery((theme: Theme) => theme.breakpoints.only("xs"));
  const classes = useStyles();

  return (
    <RightContent>
      <Grid component="section" container flexDirection="column" wrap="nowrap">
        <Box mb={1}>
          <Breadcrumbs
            separator={<NavigateNextIcon />}
            className={classes.breadcrumbs}
          >
            <Link color="secondary" url="/dashboard/users">
              <Typography variant="body2" align="center">
                List of Assigned Users
              </Typography>
            </Link>
            {!xs && <Typography variant="body2">Edit/View User</Typography>}
          </Breadcrumbs>
        </Box>
        <HeroText>Edit/View User</HeroText>
        <Box mt={2} mb={5}>
          <UserStatusPanel userInfo={userInfo} />
        </Box>
        <Box mb={5}>
          <AccountDetail userId={userInfo.id} />
        </Box>
        <Grid item md={6} xs={12}>
          <PasswordChange userId={userInfo.id} />
        </Grid>
      </Grid>
    </RightContent>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  breadcrumbs: {
    [theme.breakpoints.down("sm")]: {
      "& li": {
        display: "block",
        width: "100%",
      },
    },
  },
}));
